import $ from "jquery";
import axios from "axios";
import {USER_BOOKMAKER_ADD, USER_BOOKMAKER_DELETE} from "Core/links";
import {bookmakerAddHandler, bookmakerRemoveHandler} from "../../common/dataLayer/data-layer-metrica-handlers";
import {isMobile} from "Core/screenSizes";
import {CHANGE_CONTENT} from '../../../common/events';
import {NEED_BE_REGISTERED} from "../../../core/error-codes";

const TOOLTIP_KEY = 'bookmaker_tooltip';
const inProcessMap = {};

export const userMaterialBookmakerHandlers = () => {
    showTooltip();
    $(document).on('click', '.bookmark:not(.bookmark--active)', function () {
        if (inProcessMap[$(this).data('materialId')] !== undefined) {
            return;
        }

        inProcessMap[$(this).data('materialId')] = true;

        axios.post(USER_BOOKMAKER_ADD, {
            materialId: $(this).data('materialId'),
        })
            .then((response) => {
                if (response.data.status !== undefined) {
                    bookmakerAddHandler($(this).data('materialId'));
                    $(this).addClass('bookmark--active');

                    if ($('.bookmaker-animation').length === 0) {
                        $('body').append('<div class="bookmaker-animation"></div>');

                        $('.bookmaker-animation').offset({
                            top: $('.bookmark:last').offset().top,
                            left: $('.bookmark:last').offset().left
                        });

                        let profileOffset = $('.header-in-out.header-in-out__profile').offset();
                        let bookmakerAnimationOffset = $('.bookmaker-animation').offset();

                        let left = Math.abs(bookmakerAnimationOffset.left - profileOffset.left - 3);
                        let animationProperties = {
                            top: `-=${bookmakerAnimationOffset.top - profileOffset.top + $('.header-in-out.header-in-out__profile').height()}px`
                        }

                        if (bookmakerAnimationOffset.left > profileOffset.left) {
                            animationProperties.left = `-=${left}px`;
                        } else {
                            animationProperties.left = `+=${left}px`;
                        }

                        $('.bookmaker-animation').animate(animationProperties, 1000, function () {
                            $(this).animate({
                                top: `+=${$('.header-in-out.header-in-out__profile').height()}px`,
                                opacity: 0
                            }, 1000, function () {
                                $(this).remove();
                            });
                        });
                    }
                }
                delete (inProcessMap[$(this).data('materialId')]);
            }).catch((error) => {

            if (error.response !== undefined && error.response.data.code === NEED_BE_REGISTERED) {
                $('#signin-button').click();
            }

            delete (inProcessMap[$(this).data('materialId')]);
        });
    });

    $(document).on('click', '.bookmark--active', function () {
        if (inProcessMap[$(this).data('materialId')] !== undefined) {
            return;
        }

        inProcessMap[$(this).data('materialId')] = true;

        axios.post(USER_BOOKMAKER_DELETE, {
            materialId: $(this).data('materialId'),
        })
            .then((response) => {
                if (response.data.status !== undefined) {
                    bookmakerRemoveHandler($(this).data('materialId'));
                    $(this).removeClass('bookmark--active');
                }

                delete (inProcessMap[$(this).data('materialId')]);
            });
    });
};

const showTooltip = () => {
    document.addEventListener(CHANGE_CONTENT, function (event) {
        if ($('.material-content__bookmark:last').length === 0 || $('.material-content__bookmark:last').offset() === undefined) {
            return;
        }

        $('.bookmaker-tooltip').offset({
            top: $('.material-content__bookmark:last').offset().top - 83,
            left: isMobile() ? 'auto' : $('.material-content__bookmark:last').offset().left - 145
        });

        if (isMobile() && window.outerWidth - $('.material-content__bookmark:last').offset().left > 32) {
            $('.bookmaker-tooltip').css({right: `${window.outerWidth - $('.material-content__bookmark:last').offset().left - 32}px`})
        }
    });

    if (window.localStorage.getItem(TOOLTIP_KEY) !== null) {
        return;
    }

    if ($('.material-content__bookmark:last').length === 0 || $('.material-content__bookmark:last').offset() === undefined) {
        return;
    }

    $('body').append('<div class="bookmaker-tooltip"><div class="bookmaker-tooltip-title">На Голе появились закладки</div><div class="bookmaker-tooltip-text">Теперь не потеряете тексты и прочитаете все в удобное время</div></div>');

    if($('.material-content__bookmark:last').length !== 0){
        $('.bookmaker-tooltip').offset({
            top: $('.material-content__bookmark:last').offset().top - 83,
            left: isMobile() ? 'auto' : $('.material-content__bookmark:last').offset().left - 145
        });

        if (isMobile() && window.outerWidth - $('.material-content__bookmark:last').offset().left > 32) {
            $('.bookmaker-tooltip').css({right: `${window.outerWidth - $('.material-content__bookmark:last').offset().left - 32}px`})
        }
    }

    window.localStorage.setItem(TOOLTIP_KEY, Date.now());
    setTimeout(() => {
        $('.bookmaker-tooltip').animate({opacity: 0}, 1000);
    }, 10000);
}
